export default __webpack_public_path__ + "static/media/maintainBubble.d5254bfd.png";